/**
 * Достаёт из ответа FastAPI структурированный detail (code, message) и вешает на Error.
 * @param {Error} err
 * @param {unknown} data — тело JSON ответа
 * @param {string} fallbackMessage
 */
export function attachApiErrorDetail(err, data, fallbackMessage) {
  if (!err || typeof err !== 'object') return err;
  const d = data && typeof data === 'object' ? data.detail : undefined;
  if (d && typeof d === 'object' && !Array.isArray(d) && d.code) {
    err.code = d.code;
    err.payload = d;
    if (typeof d.message === 'string' && d.message.trim()) {
      err.message = d.message.trim();
    } else if (typeof err.message !== 'string' || !err.message.trim()) {
      err.message = fallbackMessage;
    }
  } else if (typeof d === 'string' && d.trim()) {
    err.message = d.trim();
  } else if (typeof err.message !== 'string' || !err.message.trim()) {
    err.message = fallbackMessage;
  }
  return err;
}
